module.exports = __webpack_public_path__ + "static/media/starshipit3.e20ed6df.jpg";